window.addEvent('domready', function () {

    var worksheetContainer = document.getElementById('worksheetGenerator');
    var addMissingWord = new AddMissingWord();
    var boardSize = new BoardSize();
    var buttonActivation = new ButtonActivation();
    var checkboxValues = {useDiagonals: 1, positiveResultsOnly: 1, restrictedFirstOperand: 1,
        sumLimit: 0, displayProblemNumbers: 1, includeAxes: 0, useGuides: 0};
    var colorPickerSelector = new ColorPickerSelector();
    var digitsSelection = new DigitsSelection();
    var dropdownValues = {regrouping: 'no', regroupingTypes1: 'no', regroupingTypes10: 'no', regroupingTypes100: 'no', linesPerInch: 2
          };
    var inputValues = {difficultyLevel: 'medium', size: 'medium',boardHeight: 10, boardWidth: 10, firstNumberRangeMin: 10, secondNumberRangeMin: 10, firstNumberRangeMax: 99,
        secondNumberRangeMax: 99, restrictedFirstOperandValue: 5, sumLimitValue: 10, gridColor: '#a19e9e', numberOfProblems: 20,
        startingNumber: 1, endingNumber: 10, increment: 1, letterCase: 'uppercase', orientation: 'vertical',units: 'inches',
        strokeWidth: 1,lines: 7};
    var messages = new Messages();
    var metaInfo = new MetaInfo();
    var openAjaxRequest = false;
    var persistWorksheet = new PersistWorksheet();
    var regrouping = new Regrouping();
    var restrictedFirstOperand = new RestrictedFirstOperand();
    var saveAndSubmitRequest = new SaveAndSubmitRequest();
    var selectImage = new SelectImage();
    var templateActivation = new TemplateActivation();
    var wordsBox = new WordsBox();
    var wordsList = false;
    var worksheetTabs = new WorksheetTabs();
    var worksheetTypes = new WorksheetTypes();

    function WorksheetTypes() {
        this.worksheetTypeImages = $$('.worksheetTypeImage img');
        this.worksheetTypeCaptions = $$('.worksheetTypeCaption');

        this.removeAllHoverEffects = function () {
            this.worksheetTypeImages.removeClass('thumbnailHover');
            this.worksheetTypeCaptions.removeClass('worksheetTypeCaptionHover');
        };

        this.addImageHoverEffect = function (element) {
            var thumbnail = element.getPrevious().getChildren()[0];
            thumbnail.addClass('thumbnailHover');
        };

        this.addCaptionHoverEffect = function (element) {
            var caption = element.getParent().getNext();
            caption.addClass('worksheetTypeCaptionHover');
        };
    }

    $$('.worksheetTypeCaption').addEvent('mouseenter', function () {
        worksheetTypes.removeAllHoverEffects();
        worksheetTypes.addImageHoverEffect(this);
    });

    $$('.worksheetTypeImage img').addEvent('mouseenter', function () {
        worksheetTypes.removeAllHoverEffects();
        worksheetTypes.addCaptionHoverEffect(this);
    });

    $$('.worksheetTypeCaption').addEvent('mouseleave', function () {
        worksheetTypes.removeAllHoverEffects();
    });

    $$('.worksheetTypeImage img').addEvent('mouseleave', function () {
        worksheetTypes.removeAllHoverEffects();
    });

    function WorksheetTabs() {
        this.elements = [0, 1];
        this.leftContainer = worksheetContainer.getElements('.leftContainer');
        this.previewElement = worksheetContainer.getElement('.rightContainer');

        this.moveTo = function (element) {
            this.hideCurrentElement();
            var clickedElement = this.extractElementName(element);
            this.moveToElement(clickedElement);
        };

        this.extractElementName = function (element) {
            var classes = element.className.split(' ');
            var elementName = classes[1].split('tab');
            return elementName[1];
        };

        this.moveToElement = function (element) {
            var nextContainer = worksheetContainer.getElement('.container'+element);
            nextContainer.setStyle('display', 'table-cell');
            var nextTab = worksheetContainer.getElement('.tab'+element);
            nextTab.addClass('active');
            this.adjustImages(element);
            this.adjustPreviewHeight(element);
        };

        this.moveNext = function () {
            var currentElement = this.hideCurrentElement();
            var nextElement = this.getNextElement(currentElement);
            if (nextElement) {
                this.moveToElement(nextElement);
            }
        };

        this.hideCurrentElement = function () {
            var classes = worksheetContainer.getElement('div.topNav .active').className.split(' ');
            var displayedElementName = classes[1].split('tab')[1];
            $$('.tabButton').removeClass('active');
            var currentContainer = worksheetContainer.getElement('.container'+displayedElementName);
            currentContainer.setStyle('display', 'none');

            return displayedElementName;
        };

        this.getNextElement = function (element) {
            for (var i = 0; i < this.elements.length - 1; i++) {
                if (element == this.elements[i]) {
                    var nextElement = worksheetContainer.getElement('.container'+this.elements[i+1]);
                    if (nextElement) {
                        return this.elements[i+1];
                    }
                }
            }
            return false;
        };

        this.adjustImages = function (nextElement) {
            for (var i = 0; i < this.elements.length; i++) {
                var img = worksheetContainer.getElement('.tab'+this.elements[i]+' img');
                if (img) {
                  if (nextElement == this.elements[i]) {
                      img.src = img.src.replace('-inactive', '-active');
                  }
                  else {
                      img.src = img.src.replace('-active', '-inactive');
                  }
                }
            }
        };

        this.toggleNextButtonDisplay = function (element) {
            element = parseInt(element);
            var nextButton = worksheetContainer.getElement('.nextButton');

            if (element < this.elements.length) {
                var nextTab = worksheetContainer.getElement('.container'+this.elements[element+1]);
                if (nextTab) {
                    nextButton.setStyle('display', 'table-cell');
                }
                else {
                    nextButton.setStyle('display', 'none');
                }
            }
            else {
                nextButton.setStyle('display', 'none');
            }
        };

        this.adjustPreviewHeight = function (element) {
            // var leftContainerSize = this.leftContainer[element].getSize();
            // this.previewElement.setStyle('height', leftContainerSize.y - 70 + 'px');
        }
    }

    $$('.tabButton').addEvent( 'click', function () {
        worksheetTabs.moveTo(this);
    });

    $$('.worksheetButtons.nextButton').addEvent('click', function() {
        if (!buttonActivation.buttonActive(this)) {
            return false;
        }
        worksheetTabs.moveNext();
    });

    function SaveAndSubmitRequest() {
        this.command = 'display';
        this.textInputElements = worksheetContainer.getElements('.worksheetInputText');
        this.wordsElement = worksheetContainer.getElement('.words');
        this.radioInputElements = worksheetContainer.getElements('.worksheetInputRadio');
        this.checkboxInputElements = worksheetContainer.getElements('.worksheetInputCheckbox');
        this.dropdownInputElements = worksheetContainer.getElements('.worksheetInputSelect');
        this.options = { keepAlgorithm: 0, answerKey: 0, preview: 1,
            saveWorksheetTitle: '', worksheetId: 0
        };

        this.setOptionsDefaultValues = function () {
            this.command = 'display';
            this.options.keepAlgorithm = 1;
            this.options.answerKey = 0;
            this.options.preview = 1;
            this.saveWorksheetTitle = '';
            this.worksheetId = 0;
        };

        this.runWorksheetRequest = function () {
            this.setOptionsDefaultValues();
            this.options.keepAlgorithm = 0;
            this.runStandardRequest();
        };

        this.runSameWorksheetRequest = function () {
            this.setOptionsDefaultValues();
            this.runStandardRequest();
        };

        this.runAnswerKeyRequest = function () {
            this.setOptionsDefaultValues();
            this.options.answerKey = 1;
            this.runStandardRequest();
        };

        this.runTemplateRequest = function () {
            templateActivation.deactivateTemplates();
            this.setOptionsDefaultValues();
            this.runStandardRequest();
        };

        this.saveWorksheetRequest = function (saveWorksheetTitle) {
            this.setOptionsDefaultValues();
            this.command = 'save';
            this.options.saveWorksheetTitle = saveWorksheetTitle;
            runRequest(this.createQueryString(), persistWorksheet.saveRequestCallback);
        };

        this.loadWorksheetRequest = function (worksheetId) {
            this.setOptionsDefaultValues();
            this.command = 'load';
            this.options.worksheetId = worksheetId;
            runRequest(this.createQueryString(), persistWorksheet.loadWorksheetCallback);
        };

        this.deleteWorksheetRequest = function (worksheetId) {
            this.setOptionsDefaultValues();
            this.command = 'delete';
            this.options.worksheetId = worksheetId;
            runRequest(this.createQueryString(), function () {});
        };

        this.download = function (answerKey) {
            this.setOptionsDefaultValues();
            this.command = 'download';
            this.options.answerKey = answerKey;
            this.options.preview = 0;

            // Pass along title at this point.
            const selected = worksheetContainer.getElement('.savedWorksheetSelect').getSelected()[0];

            // Position 0 is the ellipsis, meaning the user has not selected a saved worksheet.
            if (selected.get('value') !== "0") {
              this.options.title = selected.get('text');
            }

            runRequest(this.createQueryString(), saveDataCallback);
        };

        this.deleteData = function () {
            this.setOptionsDefaultValues();
            this.command = 'delete';
            runRequest(this.createQueryString(), generatePreview);
        };

        this.runStandardRequest = function () {
            messages.hideAllMessages();
            runRequest(this.createQueryString(), generatePreview);
        };

        this.createQueryString = function () {
            return '&options=' + encodeURIComponent(JSON.stringify(this.getMemberInput()));
        };

        this.getMemberInput = function () {
            var memberOptions = this.getTextInputs();

            var radioInputs = this.getRadioInputs();
            if (radioInputs) {
                memberOptions = mergeObjects(memberOptions, radioInputs);
            }

            var checkboxInputs = this.getCheckboxInputs();
            if (checkboxInputs) {
                memberOptions = mergeObjects(memberOptions, checkboxInputs);
            }

            var dropdownInputs = this.getDropdownInputs();
            if (dropdownInputs) {
                memberOptions = mergeObjects(memberOptions, dropdownInputs);
            }

            memberOptions['command'] = this.command;
            memberOptions['words'] = this.getWords();
            memberOptions['templateId'] = this.getTemplateId();

            memberOptions = mergeObjects(memberOptions, this.options);

            return memberOptions;
        };

        this.getTextInputs = function () {
            var textInputs = {};
            if (this.textInputElements.length > 0) {
                for (var i = 0; i < this.textInputElements.length; i++) {
                    textInputs[this.textInputElements[i].name] = this.textInputElements[i].value;
                }
            }
            return textInputs;
        };

        this.getRadioInputs = function () {
            var radioInputs = {};
            if (this.radioInputElements) {
                for (var i = 0; i < this.radioInputElements.length; i++) {
                    if (this.radioInputElements[i].checked) {
                        radioInputs[this.radioInputElements[i].name] = this.radioInputElements[i].value;
                    }
                }
            }
            return radioInputs;
        };

        this.getCheckboxInputs = function () {
            var checkboxInputs = {};
            if (this.checkboxInputElements) {
                for (var i = 0; i < this.checkboxInputElements.length; i++) {
                    if (this.checkboxInputElements[i].checked) {
                        if (checkboxInputs[this.checkboxInputElements[i].name] instanceof Array == false) {
                            checkboxInputs[this.checkboxInputElements[i].name] = [];
                        }
                        checkboxInputs[this.checkboxInputElements[i].name].push(this.checkboxInputElements[i].value);
                    }
                }
            }
            return checkboxInputs;
        };

        this.getDropdownInputs = function () {
            var dropdownInputs = {};
            if (this.dropdownInputElements.length > 0) {
                for (var i = 0; i < this.dropdownInputElements.length; i++) {
                    dropdownInputs[this.dropdownInputElements[i].name] = this.dropdownInputElements[i].get('value');
                }
            }
            return dropdownInputs;
        }

        this.getWords = function () {
            var words = '';
            if (wordsBox.wordListValid() && this.wordsElement) {
                words = this.wordsElement.value.trim();
            }
            return words;
        };

        this.getTemplateId = function () {
            var templateId = 0;
            var templateElement = worksheetContainer.getElement('.active_template');
            if (templateElement) {
                templateId = templateElement.getParent().id;
            }
            return templateId;
        };
    }

    function mergeObjects(obj1, obj2) {
        for (var arrayOption in obj2) {
            obj1[arrayOption] = obj2[arrayOption];
        }

        return obj1;
    }

    function generatePreview(response) {
        if (response.errors !== null) {
            messages.displayErrorMessage(response.errors);
            buttonActivation.activateOnlyCreateButton();
            buttonActivation.algorithmExists = false;
        }
        else if (response.warnings !== null) {
            messages.displayWarningMessage(response.warnings);
            buttonActivation.algorithmExists = response.algorithm;
        }
        else {
            buttonActivation.algorithmExists = response.algorithm;
            // Since users can save a worksheet with error, when they switch from an error worksheet to a normal one
            // hide the error message.
            if (messages.errorMessagesDisplayed()) {
              messages.hideErrorMessage();
            }
        }

        if (saveAndSubmitRequest.options.answerKey == 0) {
            togglePreviewTab(worksheetContainer.getElement('.worksheet'));
        }


        worksheetContainer.getElement('.preview').innerHTML = response.page[0];
        if (response.additionalInfo){
            worksheetContainer.getElement('.inputTitle').value = response.additionalInfo.title;
        }
        if (wordsBox.words) {
            if (response.words) {
                words.value = response.words;
            }
            wordsBox.toggleWordsTextColor();
        }
        worksheetTitleMetaInfo = response.metaInfo.title;
        metaInfo.refreshTitle();
        templateActivation.activateTemplates();
        templateActivation.activateTemplateFromResponse(response);
        buttonActivation.toggleButtons();
        buttonActivation.hideLoader();
    }

    function Messages () {
        this.errorMessageContainer = worksheetContainer.getElement('.errorMessage');
        this.warningMessageContainer = worksheetContainer.getElement('.warningMessage');

        this.displayErrorMessage = function (messageText) {
            this.errorMessageContainer.innerHTML = messageText;
            this.errorMessageContainer.setStyle('display', 'block');
        };

        this.displayWarningMessage = function (messageText) {
            this.warningMessageContainer.innerHTML = messageText;
            this.warningMessageContainer.setStyle('display', 'block');
        };


        this.hideErrorMessage = function () {
            this.errorMessageContainer.setStyle('display', 'none');
        };

        this.hideWarningMessage = function () {
            this.warningMessageContainer.setStyle('display', 'none');
        };

        this.hideAllMessages = function () {
            this.hideErrorMessage();
            this.hideWarningMessage();
        };

        this.errorMessagesDisplayed = function () {
          return this.errorMessageContainer.style.display === 'block';
        }
    }

    $(document).addEvent("click:relay(.templateThumbnail)", function () {
        if (!templateActivation.templatesActive()) {
            return false;
        }

        templateActivation.activateTemplate(this);
        saveAndSubmitRequest.runTemplateRequest();
        togglePreviewTab(worksheetContainer.getElement('.worksheet'));
    });

    function TemplateActivation() {
        this.templatesElement = worksheetContainer.getElements('.templateThumbnail');

        this.activateTemplates = function () {
            for (var i = 0; i < this.templatesElement.length; i++) {
                this.templatesElement[i].removeClass('inactiveTemplate');
            }
        };

        this.deactivateTemplates = function () {
            for (var i = 0; i < this.templatesElement.length; i++) {
                this.templatesElement[i].addClass('inactiveTemplate');
            }
        };

        this.templatesActive = function () {
            if (this.templatesElement[0].hasClass('inactiveTemplate')) {
                return false;
            }
            return true;
        };

        this.activateTemplate = function (element) {
            for (var i = 0; i < this.templatesElement.length; i++) {
                var activeTemplate = this.templatesElement[i].getElement('img');
                if (activeTemplate) {
                    activeTemplate.removeClass('active_template');
                }
            }
            element.getElement('img').addClass('active_template');
        };

        this.getTemplateIdFromResponse = function (response) {
            var templateId;
            if (response.templateId != 0) {
                templateId = response.templateId;
            }
            else {
                templateId = worksheetContainer.getElement('.templateThumbnail').id;
            }

            return templateId;
        };

        this.activateTemplateFromResponse = function (response) {
            var templateId = this.getTemplateIdFromResponse(response);
            this.activateTemplate(worksheetContainer.getElement('#'+templateId));
        }
    }

    function ButtonActivation () {
        this.algorithmExists = false;
        this.wordsElement = worksheetContainer.getElement('.words');
        this.createButtonElement = worksheetContainer.getElements('.create');
        this.refreshButtonElement = worksheetContainer.getElements('.refresh');
        this.nextButtonElement = worksheetContainer.getElements('.nextButton');
        this.numericOptions = worksheetContainer.getElements('.numericInput');
        this.numericRange = worksheetContainer.getElements('.numericRange');
        this.createBtnLoader = worksheetContainer.getElements('.create-btn-loader');

        this.downloadButtons = worksheetContainer.getElements('.downloadButtons .downloadWorksheet');
        this.assignWorksheetButton = worksheetContainer.getElements('.assign-worksheet-generator');
        this.saveWorksheetButtonElement = worksheetContainer.getElements('.saveWorksheetButton');
        this.deleteWorksheetButtonElement = worksheetContainer.getElements('.deleteWorksheetButton');

        this.wordListChanged = function () {
            var currentWordsList = this.wordsElement.value.trim();
            if (currentWordsList == wordsList) {
                return false;
            }

            return true;
        };

        this.textInputsValid = function () {
            return wordsBox.wordListValid() && this.numericOptionsValid();
        };

        //Checks that other required options such as board height and width are filled.
        this.numericOptionsValid = function () {
            for (var i = 0; i < this.numericOptions.length; i++) {
                if (this.numericOptions[i]) {
                    var optionValue = this.numericOptions[i].value.trim();
                    if (optionValue == '' || isNaN(optionValue) || optionValue <= 0) {
                        return false;
                    }
                }
            }

            return true;
        };

        this.toggleButtons = function () {
          if (wordsBox.words) {
                if (this.textInputsValid()) {
                    if (this.wordListChanged() || this.inputValuesChanged() ||
                        this.checkboxValuesChanged() || this.dropdownInputsChanged()) {
                        this.activateOnlyCreateButton();
                    }
                    else if (this.algorithmExists) {
                        this.deactivateOnlyCreateButton();
                    }
                }
                else {
                    this.deactivateAllButtons();
                }
            }
            else if (this.numericInputsExist()) {
                if (this.numericInputsValid()) {
                    if (this.inputValuesChanged() || this.checkboxValuesChanged()
                        || this.dropdownInputsChanged()) {
                        this.activateOnlyCreateButton();
                    }
                    else if (this.algorithmExists) {
                        this.deactivateOnlyCreateButton();
                    }
                }
            }
            else if (this.dropdownInputsExist() || this.checkboxInputsExist()) {
                if (this.dropdownInputsExist() && this.dropdownInputsChanged()) {
                    this.activateOnlyCreateButton();
                }
                else if (this.checkboxInputsExist() && this.checkboxValuesChanged()) {
                    this.activateOnlyCreateButton();
                }
                else if (this.algorithmExists) {
                    this.deactivateOnlyCreateButton();
                }
            }
            else {
                this.deactivateAllButtons();
            }
        };

        this.inputValuesChanged = function () {
            for (var inputValue in inputValues) {
                var currentInputValue = worksheetContainer.getElement('.'+inputValue);
                if (currentInputValue&&currentInputValue.value!=null) {
                    currentInputValue = currentInputValue.value.trim();
                  if (inputValues[inputValue] != currentInputValue) {
                        return true;
                    }
                }
            }

            return false;
        };

        this.numericInputsValid = function () {
            return this.numericOptionsValid() && this.numericRangeValid();
        };

        this.numericInputsExist = function () {
            for (var inputValue in inputValues) {
                var currentInputValue = worksheetContainer.getElement('.'+inputValue);
                if (currentInputValue) {
                    return true;
                }
            }

            return false;
        };

        this.numericRangeValid = function () {
            for (var i = 0; i < this.numericRange.length; i++) {
                if (this.numericRange[i]) {
                    var inputValue = this.numericRange[i].value.replace(' ', '');
                    if (!this.isNumber(inputValue)) {
                        return false;
                    }
                }

            }

            return true;
        };

        this.isNumber = function (input) {
            if (input == '' || isNaN(input) || !isFinite(input)) {
                return false;
            }

            return true;
        };

        this.checkboxInputsExist = function () {
            for (var checkboxValue in checkboxValues) {
                var currentcheckboxElement = worksheetContainer.getElement('.'+checkboxValue);
                if (currentcheckboxElement) {
                    return true;
                }
            }

            return false;
        };

        this.checkboxValuesChanged = function () {
            for (var checkboxValue in checkboxValues) {
                var currentCheckboxElement = worksheetContainer.getElement('.'+checkboxValue);
                if (currentCheckboxElement) {
                    var checkedStatus = 0;
                    if (currentCheckboxElement.checked) {
                        checkedStatus = 1;
                    }

                    if (checkboxValues[checkboxValue] != checkedStatus) {
                        return true;
                    }
                }
            }

            return false;
        };

        this.dropdownInputsExist = function () {
            for (var dropdownValue in dropdownValues) {
                var currentdropdownElement = worksheetContainer.getElement('.'+dropdownValue);
                if (currentdropdownElement) {
                    return true;
                }
            }

            return false;
        };

        this.dropdownInputsChanged = function () {
            for (var dropdownValue in dropdownValues) {
                var currentdropdownElement = worksheetContainer.getElement('.'+dropdownValue);
                if (currentdropdownElement) {
                    if (dropdownValues[dropdownValue] != currentdropdownElement.get('value')) {
                        return true;
                    }
                }
            }

            return false;
        };

        this.showLoader = async function () {
          // Show loader after 0.5s to avoid it flashing on the screen on fast responses
            this.loaderTimeout = setTimeout(() => {
              this.createBtnLoader.removeClass('hiddenElement');
            }, 500);
        }

        this.hideLoader = function () {
            if ('loaderTimeout' in this) {
              clearTimeout(this.loaderTimeout);
            }
            this.createBtnLoader.addClass('hiddenElement');
        }

        this.activateCreateButton = function () {
            this.activateButtons(this.createButtonElement);
        };

        this.activateRefreshButton = function () {
            this.activateButtons(this.refreshButtonElement);
        };

        this.activateNextButton = function () {
            var button = {};
            button.element = this.nextButtonElement;
            button.classToAdd = 'activeNextButton';
            button.classToRemove = 'inactiveNextButton';
            button.strToReplace = '-inactive.';
            button.strToReplaceWith = '-active.';
            this.toggleButton(button);
        };

        this.activateButtons = function (element) {
            element.removeClass('disabled').removeClass('disabled');
            element.forEach((elem) => elem.removeAttribute('disabled'));
        };

        this.activateDownloadButtons = function () {
            this.activateButtons(this.downloadButtons);
        };

        this.activateAssignButton = function () {
            this.activateButtons(this.assignWorksheetButton);
        };

        this.activateOnlyCreateButton = function () {
            this.activateCreateButton();
            this.deactivateRefreshButton();
            this.deactivateNextButton();
            this.deactivateDownloadButtons();
        };

        this.deactivateAllButtons = function () {
            this.deactivateCreateButton();
            this.deactivateRefreshButton();
            this.deactivateNextButton();
            this.deactivateDownloadButtons();
        };

        this.deactivateCreateButton = function () {
            this.deactivateButtons(this.createButtonElement);
        };

        this.deactivateRefreshButton = function () {
            this.deactivateButtons(this.refreshButtonElement);
        };

        this.deactivateNextButton = function () {
            var button = {};
            button.element = this.nextButtonElement;
            button.classToAdd = 'inactiveNextButton';
            button.classToRemove = 'activeNextButton';
            button.strToReplace = '-active.';
            button.strToReplaceWith = '-inactive.';
            this.toggleButton(button);
        };

        this.deactivateButtons = function (element) {
            element.addClass('disabled');
            element.forEach((elem) => elem.setAttribute('disabled', ''));
        };

        this.deactivateDownloadButtons = function () {
            this.deactivateButtons(this.downloadButtons);
        };

        this.deactivateOnlyCreateButton = function () {
            this.deactivateCreateButton();
            this.activateRefreshButton();
            this.activateNextButton();
            this.activateDownloadButtons();
            if (this.assignWorksheetButton) {
                this.activateAssignButton();
            }
        };

        this.buttonActive = function (element) {
            if (element.hasClass('disabled')
            || element.hasClass('inactiveNextButton')) {
                return false;
            }
            return true;
        };

        this.toggleButton = function (button) {
            button.element.addClass(button.classToAdd);
            button.element.removeClass(button.classToRemove);
            for (var i=0; i < button.element.length; i++ ) {
                var img = button.element[i].getElement('img');
                img.src = img.src.replace(button.strToReplace, button.strToReplaceWith);
            }
        };

        this.activateSaveWorksheetButton = function () {
            this.activateButtons(this.saveWorksheetButtonElement);
        };

        this.deactivateSaveWorksheetButton = function () {
            this.deactivateButtons(this.saveWorksheetButtonElement);
        };

        this.toggleSaveWorksheetButton = function () {
            if (persistWorksheet.canSaveWorksheet()) {
                this.activateSaveWorksheetButton();
            }
            else {
                this.deactivateSaveWorksheetButton();
            }
        };

        this.activateDeleteListButton = function () {
            this.activateButtons(this.deleteWorksheetButtonElement);
        };

        this.deactivateDeleteListButton = function () {
            this.deactivateButtons(this.deleteWorksheetButtonElement);
        };

        this.setInputValues = function () {
            for (var inputValue in inputValues) {
                var currentInputValue = worksheetContainer.getElement('.'+inputValue);
              if (currentInputValue && currentInputValue.value != null) {
                    inputValues[inputValue] = currentInputValue.value.trim();
                }
            }

            for (var checkboxValue in checkboxValues) {
                var currentCheckboxElement = worksheetContainer.getElement('.'+checkboxValue);
                if (currentCheckboxElement) {
                    var checkedStatus = 0;
                    if (currentCheckboxElement.checked) {
                        checkedStatus = 1;
                    }

                    checkboxValues[checkboxValue] = checkedStatus;
                }
            }

            for (var dropdownValue in dropdownValues) {
                var currentDropdownValue = worksheetContainer.getElement('.'+dropdownValue);
                if (currentDropdownValue) {
                    dropdownValues[dropdownValue] = currentDropdownValue.get('value');
                }
            }
        };
    }

    function WordsBox() {
        this.words = worksheetContainer.getElement('.words');

        this.wordListValid = function () {
            if (this.words) {
                var wordsWithoutSpaces = removeAllSpaces(this.words.value);
                var insertWordsHereStr = removeAllSpaces(insertWordsHere);

                if (wordsWithoutSpaces == '' || wordsWithoutSpaces == insertWordsHereStr) {
                    return false;
                }
            }

            return true;
        };

        this.toggleWordsInstructions = function () {
            var wordsValue = removeAllSpaces(this.words.value);
            var insertWordsHereStr = removeAllSpaces(insertWordsHere);

            if (wordsValue.length == 0) {
                this.words.value = insertWordsHere;
                this.understateWordsContainer();
            }
            else if (wordsValue == insertWordsHereStr) {
                this.removeWordsInstructions();
            }
        };

        this.removeWordsInstructions = function () {
            if (this.words) {
                this.words.value = '';
            }
            this.emphasizeWordsContainer();
        };

        this.understateWordsContainer = function () {
            if (this.words) {
                this.words.setStyle('color', '#7f8c8d');
            }
        };

        this.emphasizeWordsContainer = function () {
            if (this.words) {
                this.words.setStyle('color', '#444444');
            }
        };

        this.toggleWordsTextColor = function () {
            if (this.wordListValid()) {
                this.emphasizeWordsContainer();
            }
            else {
                this.understateWordsContainer();
            }
        };
    }

    function removeAllSpaces(input) {
        return input.replace(/\s+/g,'');
    }

    function PersistWorksheet() {
        this.wordsContainer = worksheetContainer.getElement('.words');
        this.saveWorksheetTitle = worksheetContainer.getElement('.saveWorksheetTitle');
        this.savedWorksheetSelect = worksheetContainer.getElement('.savedWorksheetSelect');
        this.selectedWordListOption = null;
        this.selectedWordListOptionValue = null;

        this.loadWorksheet = function () {
            this.updateWordListSelectedOption();
            if (this.selectedWordListOptionValue !== undefined
                && this.selectedWordListOptionValue != 0) {
                saveAndSubmitRequest.loadWorksheetRequest(this.selectedWordListOptionValue);
                wordsBox.emphasizeWordsContainer();
                return true;
            }
            return false;
        };

        this.loadWorksheetCallback = function (response) {
            generatePreview(response);

            persistWorksheet.loadWordsTab(response);
            persistWorksheet.loadTemplatesTab(response);
            persistWorksheet.loadAdditionalInfoTab(response);

            persistWorksheet.loadSettings(response);
            buttonActivation.toggleSaveWorksheetButton();
            buttonActivation.deactivateOnlyCreateButton();
            if (messages.errorMessagesDisplayed()) {
              buttonActivation.deactivateDownloadButtons();
            }
        };

        this.loadWordsTab = function (response) {
            if (persistWorksheet.wordsContainer) {
                persistWorksheet.wordsContainer.value = response.words;
                wordsList = persistWorksheet.wordsContainer.value.trim();
            }
        };

        this.loadTemplatesTab = function (response) {
            var templateId = templateActivation.getTemplateIdFromResponse(response);
            templateActivation.activateTemplate(worksheetContainer.getElement('#'+templateId));
        };

        this.loadAdditionalInfoTab = function (response) {
            worksheetContainer.getElement('.inputTitle').value = response.additionalInfo.title;
            var savedWorksheetDropdownSelection = this.savedWorksheetSelect.getSelected()[0].get('text');
            if (savedWorksheetDropdownSelection) {
              this.saveWorksheetTitle.value = savedWorksheetDropdownSelection;
            }
            metaInfo.refreshTitle();
        };

        this.loadSettings = function (response) {
            if (response.algorithmOptions !== undefined && response.algorithmOptions !== null) {
                this.removeCheckedFromCheckboxes();
                for (var responseValue in response.algorithmOptions) {
                    var element = worksheetContainer.getElement('#'+responseValue);
                    if (element) {
                        var elementType = element.get('type');
                        switch (elementType) {
                            case 'text':
                                element.set('value', response.algorithmOptions[responseValue]);
                                if (colorPickerSelector.worksheetGeneratorColorPicker !== undefined) {
                                    colorPickerSelector.worksheetGeneratorColorPicker.setHex(element.value);
                                }
                                break;
                            case 'select-one':
                                element.set('value', response.algorithmOptions[responseValue]);
                                break;
                            case 'checkbox':
                                element.set('checked', true);
                                break;
                            default:
                                break;
                        }
                    }
                }
            }
        };

        this.removeCheckedFromCheckboxes = function () {
            var checkboxElements = worksheetContainer.getElements('input[type=checkbox]');
            for (var i = 0; i < checkboxElements.length; i++) {
                checkboxElements[i].set('checked', false);
            }
        };

        this.updateWordListSelectedOption = function () {
            this.selectedWordListOption = this.savedWorksheetSelect.getSelected()[0];
            this.selectedWordListOptionValue = this.selectedWordListOption.get('value');
        };

        this.saveWorksheet = function () {
            var wordsListTitle = this.saveWorksheetTitle.value.trim();
            if (wordsListTitle != '' && wordsBox.wordListValid()) {
                saveAndSubmitRequest.saveWorksheetRequest(this.saveWorksheetTitle.value.trim());
            }
        };

        this.saveRequestCallback = function (response) {
            generatePreview(response);
            if (response.worksheetId && response.saveWorksheetTitle) {
                var newWorksheet = true;
                for (var i = 0; i < this.savedWorksheetSelect.options.length; i++) {
                    if (response.saveWorksheetTitle == this.savedWorksheetSelect.options[i].text
                        && this.savedWorksheetSelect.options[i].value != 0) {
                        newWorksheet = false;
                    }
                }

                if (newWorksheet) {
                    persistWorksheet.addNewOption(response.saveWorksheetTitle, response.worksheetId);
                }
                buttonActivation.activateDeleteListButton();
            }
            buttonActivation.deactivateOnlyCreateButton();
            // When there is an error message appeared after we save and generate the preview, disable download buttons since
            // the downloaded worksheet would be blank and meaningless.
            if (messages.errorMessagesDisplayed()) {
              buttonActivation.deactivateDownloadButtons();
            }

            if (history.pushState && response.shortUrl) {
                var pathName = location.pathname.split('/');
                pathName.splice(4,10);
                if (pathName) {
                    pathName = pathName.join('/');
                    pathName += '/'+response.shortUrl;
                    window.history.pushState('', document.getElementsByTagName("title")[0].innerHTML,
                        pathName);
                    /*var url = location.protocol+'//'+location.hostname + pathName;
                    if (addthis !== 'undefined') {
                        addthis.update('share', 'url', url);
                    }*/
                }
            }
        };

        this.addNewOption = function (saveWorksheetTitle, worksheetId) {
            var newOption = new Element('option', {
                    text: saveWorksheetTitle,
                    value: worksheetId,
                    selected: true
                }
            );
            newOption.inject(this.savedWorksheetSelect);
        };

        this.deleteWorksheet = function () {
            this.updateWordListSelectedOption();
            if (this.selectedWordListOptionValue !== undefined
                && this.selectedWordListOptionValue != 0) {
                this.selectedWordListOption.remove();
                saveAndSubmitRequest.deleteWorksheetRequest(this.selectedWordListOptionValue);
            }
        };

        this.canSaveWorksheet = function () {
            var saveWorksheetTitle = this.saveWorksheetTitle.value.trim();
            return saveWorksheetTitle != '' && wordsBox.wordListValid();
        };

        this.canDeleteWorksheet = function () {
            this.updateWordListSelectedOption();
            return this.selectedWordListOptionValue != 0;
        };

        this.loadSavedWorksheetsList = function () {
            var queryString = '&getWorksheets=1';
            runRequest(queryString, this.loadSavedWorksheetsListCallback);
        };

        this.loadSavedWorksheetsListCallback = function (response) {
            for (var i = 0; i < response.length; i++) {
                persistWorksheet.addNewOption(response[i].saveWorksheetTitle, response[i].id);
            }

            persistWorksheet.savedWorksheetSelect.options[0].set('selected', 'selected');
            buttonActivation.toggleSaveWorksheetButton();
        };
    }

    $$('.savedWorksheetSelect').addEvent('change', function () {
        if (persistWorksheet.loadWorksheet()) {
            buttonActivation.activateDeleteListButton();
            buttonActivation.toggleButtons();
        }
        else {
            buttonActivation.deactivateDeleteListButton();
        }

        buttonActivation.toggleSaveWorksheetButton();
    });

    $$('.saveWorksheetTitle').addEvent('keyup', function () {
        buttonActivation.toggleSaveWorksheetButton();
    });

    $$('.saveWorksheetButton').addEvent('click', function () {
        if (!buttonActivation.buttonActive(this)) {
            return false;
        }

        if (persistWorksheet.canSaveWorksheet()) {
            persistWorksheet.saveWorksheet();
        }

        buttonActivation.toggleSaveWorksheetButton();
    });

    $$('.deleteWorksheetButton').addEvent('click', function () {
        if (!buttonActivation.buttonActive(this)) {
            return false;
        }

        if (persistWorksheet.canDeleteWorksheet()) {
            persistWorksheet.deleteWorksheet();
            buttonActivation.deactivateDeleteListButton();
        }
    });

    $$('.words').addEvents({
        input: function () {
            buttonActivation.toggleButtons();
            wordsBox.toggleWordsTextColor();
            if (userLoggedIn) {
                buttonActivation.toggleSaveWorksheetButton();
            }

            boardSize.calculateBoardSize();
        },
        focusout: function () {
            //wordsBox.toggleWordsInstructions();
        },
        blur: function () {
            wordsBox.toggleWordsInstructions();
        },
        click: function () {
            buttonActivation.toggleButtons();
            wordsBox.toggleWordsInstructions();
            wordsBox.toggleWordsTextColor();
        },
        contextmenu: function () {
            wordsBox.toggleWordsInstructions();
        },
        keydown: function () {
            if (!wordsBox.wordListValid()) {
                wordsBox.removeWordsInstructions();
            }
        }
    });

    function BoardSize() {
        this.boardHeight = worksheetContainer.getElement('.boardHeight');
        this.boardWidth = worksheetContainer.getElement('.boardWidth');
        this.words = worksheetContainer.getElement('.words');

        this.elementExistsOnPage = function () {
            return this.boardHeight && this.boardWidth;
        };

        this.calculateBoardSize = function () {
            if (this.elementExistsOnPage()) {
                var longestWord = this.getLongestWord();
                if (longestWord > this.boardHeight.get('value')) {
                  this.boardHeight.set('value',this.getNextPossibleOption(longestWord, this.boardHeight));
                  jQuery(this.boardHeight).trigger('change');
                }
                if (longestWord > this.boardWidth.get('value')) {
                  this.boardWidth.set('value',this.getNextPossibleOption(longestWord, this.boardWidth));
                  jQuery(this.boardWidth).trigger('change');
                }
            }
        };

        this.getLongestWord = function () {
            var wordsArray = this.words.value.trim();
            wordsArray = wordsArray.split('\n');
            var longestWord = 0;
            for (var i = 0; i < wordsArray.length; i++) {
                if (wordsArray[i].length > longestWord ) {
                    longestWord = wordsArray[i].length
                }
            }

            return longestWord;
        };

      this.getNextPossibleOption = function (inputValue, element) {
        var min = element.getAttribute('min') * 1;
        var max = element.getAttribute('max') * 1;
        var step = element.getAttribute('step') * 1;
        var value = min;
        if (inputValue > max) {
          return max;
        }
        while (inputValue > value) {
          value += step;
        }
        return value;
      };
    }

    $$('.boardSize').addEvent('change', function () {
        if (boardSize.boardHeightValue && boardSize.boardWidthValue) {
            this.getSiblings('.boardValue')[0].innerHTML = this.value;
        }
    });

    $$('.numericInput').addEvent('input', function () {
        this.value = removeNonNumericCharacters(this.value);
        buttonActivation.toggleButtons();
    });

    $$('.worksheetInputCheckbox').addEvent('change', function () {
        buttonActivation.toggleButtons();
    });

    $$('.worksheetInputSelect').addEvent('change', function () {
        buttonActivation.toggleButtons();
    });

    function removeNonNumericCharacters(input) {
        return input.replace(/\D/g, '');
    }

    $$('.create').addEvent('click', function () {
        if (!buttonActivation.buttonActive(this)) {
            return false;
        }

        buttonActivation.deactivateOnlyCreateButton();
        buttonActivation.showLoader();
        wordsList = worksheetContainer.getElement('.words');
        if (wordsList) {
            wordsList = wordsList.value.trim();
        }
        
        if(window.Edu && window.Edu.trackEvent) {
            window.Edu.trackEvent('Generated Worksheet',{
                name: window.worksheetGeneratorType
            },{
                eventCategory: 'worksheet generator',
                eventAction: 'create',
                eventLabel: window.worksheetGeneratorType
            });
        }

        buttonActivation.setInputValues();
        saveAndSubmitRequest.runWorksheetRequest();
        togglePreviewTab(worksheetContainer.getElement('.worksheet'));
    });

    $$('.refresh').addEvent('click', function () {
        if (!buttonActivation.buttonActive(this)) {
            return false;
        }

        saveAndSubmitRequest.runWorksheetRequest();
        togglePreviewTab($$('.worksheet')[0]);
    });


    var titleWasModified = false;

    $$('.inputTitle').addEvents({
        keyup: function () {
            if (worksheetTitleMetaInfo !== undefined) {
                metaInfo.refreshTitle();
            }
        },
        keydown: function (e) {
            var deleteKey = 46;
            var backspaceKey = 8;
            if (!titleWasModified && worksheetTitle == this.value
                && (e.code == backspaceKey || e.code == deleteKey)) {
                this.value = '';
                titleWasModified = true;
            }
        },
        keypress: function () {
            titleWasModified = true;
        }
    });

    function MetaInfo () {
        this.title = { sourceSelector: '.inputTitle', targetSelector: '.worksheetTitle',
            targetClass: 'worksheetTitle', top: 15, left: 25, fontSize: 12, color: '#000000',
            hiddenInputSelector: '.titleTextColorHidden'
        };

        this.refreshTitle = function () {
            var worksheetTitle = document.createElement('div');
            worksheetTitle.textContent = worksheetContainer.getElement(this.title.sourceSelector).value;
            worksheetTitle.className = this.title.targetClass;
            worksheetTitle.style.top = this.title.top + worksheetTitleMetaInfo.row * 0.15 + 'px';
            worksheetTitle.style.fontSize = worksheetTitleMetaInfo.fontSize * 0.55 + 'px';

            worksheetTitle.style.color = worksheetTitleMetaInfo.fillColor;
            var fontColorElement = worksheetContainer.getElement(this.title.hiddenInputSelector);
            if (fontColorElement && fontColorElement.value) {
                worksheetTitle.style.color = fontColorElement.value;
            }

            $$(this.title.targetSelector).destroy();
            this.appendToPreview(worksheetTitle);
        };

        this.appendToPreview = function (element) {
            var previewContainer = worksheetContainer.getElement('.rightContainer .previewContainer .preview');
            previewContainer.grab(element);
        };

        this.changeTitleColor = function (color) {
            $$(this.title.hiddenInputSelector).set('value', color);
            $$(this.title.targetSelector).setStyle('color', color);
        };
    }

    $(document).addEvent("click:relay(.circle)", function () {
        metaInfo.changeTitleColor(this.id);
    });

    $$('.worksheet').addEvent('click', function () {
        saveAndSubmitRequest.runSameWorksheetRequest();
        togglePreviewTab(this);
    });

    $$('.answerKey').addEvent('click', function () {
        saveAndSubmitRequest.runAnswerKeyRequest();
        togglePreviewTab(this);
    });

    function togglePreviewTab(element) {
        worksheetContainer.getElements('.previewTab').removeClass('previewTabActive');
        worksheetContainer.getElement(element).addClass('previewTabActive');
    }

    $$('.downloadWorksheet').addEvent('click', function () {
        if (!buttonActivation.buttonActive(this)) {
            return false;
        }

        var answerKey = 0;
        if (this.id == 'downloadAnswerKey') {
            answerKey = 1;
        }

        if (!window.userLoggedIn) {
          displayRegistrationPaywallPopup(false, "worksheet_generator_paywall");
          return false;
        }


        if(window.Edu && window.Edu.trackEvent) {
            window.Edu.trackEvent('Downloaded Content',{
                contentType: answerKey? 'worksheet-generator-answerkey' : 'worksheet-generator',
                section: "Worksheet Generator",
                name: window.worksheetGeneratorType
            },{
                eventCategory: 'worksheet generator',
                eventAction: 'download',
                eventLabel: window.worksheetGeneratorType
            });
        }

        saveAndSubmitRequest.download(answerKey);
    });

    function saveDataCallback(response) {
        if (response.displayPayWall) {
            displayRegistrationPaywallPopup(response.loggedIn, "worksheet_generator_paywall");
        }
        else {
            buttonActivation.toggleButtons();
            if (response && response.documentId) {
                var pdfUrl = location.protocol+'//'+location.hostname+'/download/worksheet-generator/'
                    +encodeURIComponent(response.documentId)+'/';
                if (saveAndSubmitRequest.answerKey == 1) {
                    pdfUrl += 'answer/';
                }
                window.location.href = pdfUrl;
                //var win = window.open(pdfUrl);
                //win.focus();
            }
        }
    }

    function displayRegistrationPaywallPopup(loggedIn, type) {
        if(!type){
            type = "worksheet_generator_paywall";
        }
        if (loggedIn) {
            //openPopup('Modal_WorksheetGeneratorPayWall');
            (function($){
                var paywall = $("#"+type);
                if(!paywall.length) return;
                paywall.modal('show');
                return false;
            })(window.jQuery);
        }
        else {
          window.Edu.openSignup();
        }
    }

    function openPopup(modalName) {
        new popcontroller({
            loadFromAjax: true,
            disableScroll: false,
            loadModalName: modalName,
            loadFromUrl: window.location.pathname,
            'title': '',
            'type': 'unstyled',
            initialWidth: 665,
            'extraGetObject': null,
            'onSuccessfulCompletion':function() {

            },
            'onClosing': function() {

            }
        }).popit();
    }

    $$('.warningMessage').addEvent('click', function () {
        this.setStyle('display', 'none');
    });

    $$('.moreInfo').addEvent('click', function () {
        var infoBox = $$('.infoBox')[0];
        if (infoBox.getStyle('display') == 'none') {
            infoBox.setStyle('display', 'block');
        }
        else {
            infoBox.setStyle('display', 'none');
        }
    });

    $$('.infoBox').addEvent('click', function () {
        this.setStyle('display', 'none');
    });

    function SelectImage() {
        this.wordsContainer = worksheetContainer.getElement('.words');

        this.addImageToList = function (element) {

            var selectedValue = element.getSelected().get('value')[0];

            if (selectedValue && !this.existsInList(selectedValue)) {
                // Toggle words instructions only when we have something to add
                wordsBox.toggleWordsInstructions();

                if (removeAllSpaces(insertWordsHere) === removeAllSpaces(this.wordsContainer.value)) {
                    this.wordsContainer.value = '';
                }
                if (this.wordsContainer.value) {
                  this.wordsContainer.value = this.wordsContainer.value.trim() + '\n' + selectedValue + '\n';
                }else{
                  this.wordsContainer.value = selectedValue + '\n';
                }
                wordsBox.emphasizeWordsContainer();
                buttonActivation.toggleButtons();
            }
        };

        this.existsInList = function (selectedValue) {
            var words = this.wordsContainer.value.split('\n');
            for (var i = 0; i < words.length; i++) {
                if (words[i] == selectedValue) {
                    return true;
                }
            }

            return false;
        };
    }

    $$('.imagesSelect').addEvent('click', function () {
        selectImage.addImageToList(this);
        boardSize.calculateBoardSize();
    });

    function AddMissingWord () {
        this.missingWordInput = worksheetContainer.getElement('.missingWord');
        this.addMissingWordButton = worksheetContainer.getElement('.addMissingWord');
        this.thankYouMessage = worksheetContainer.getElement('.missingWordThankYou');

        this.toggleButton = function () {
            if (addMissingWord.missingWordInput.value.trim()) {
                buttonActivation.activateButtons(addMissingWord.addMissingWordButton);
            }
            else {
                buttonActivation.deactivateButtons(addMissingWord.addMissingWordButton);
            }
        };

        this.add = function () {
            var missingWordValue = this.missingWordInput.value.replace('  ', '').trim();
            this.missingWordInput.value = '';

            if (missingWordValue != '') {
                runRequest('&addMissingWord='+encodeURIComponent(missingWordValue),
                    this.addMissingWordCallback);
            }
        };

        this.addMissingWordCallback = function () {
            addMissingWord.thankYouMessage.setStyle('display', 'inline-block');
        };
    }

    $$('.missingWord').addEvent('input', function () {
        addMissingWord.toggleButton();
        addMissingWord.thankYouMessage.setStyle('display', 'none');
    });

    $$('.addMissingWord').addEvent('click', function () {
        if (!buttonActivation.buttonActive(this)) {
            return false;
        }

        addMissingWord.add();
    });

    $$('.worksheetInputRadio').addEvent('click', function () {
        saveAndSubmitRequest.runSameWorksheetRequest();
    });

    function runRequest(queryString, functionName) {
        if (!openAjaxRequest) {
            openAjaxRequest = true;
            new Request({
                url: '/',
                method: 'post',
                onSuccess: function (response) {
                    if (response) {
                        response = JSON.parse(response);
                    }
                    functionName(response);
                    openAjaxRequest = false;
                }
            }).send('__json=WorksheetGenerator&type=' + encodeURIComponent(window.worksheetGeneratorType)
                    + queryString);
        }
    }

    if (worksheetContainer.getElement('.preview')) {
        if (worksheetId) {
            saveAndSubmitRequest.loadWorksheetRequest(worksheetId);
        }
        else {
            saveAndSubmitRequest.deleteData();
        }
    }

    if (typeof userLoggedIn !== 'undefined' && userLoggedIn) {
        var timerId = setInterval(function () {
            if (!openAjaxRequest) {
                persistWorksheet.loadSavedWorksheetsList();
                clearInterval(timerId);
            }
        }, 500);
    }

    function DigitsSelection () {
        this.numDigits = worksheetContainer.getElement('.digits');
        this.numericRangeTextInputs = worksheetContainer.getElements('.numericRange');
        this.simpleOptionsContainer = worksheetContainer.getElement('.digitsSimpleOptionsContainer');
        this.advancedOptionsContainer = worksheetContainer.getElement('.digitsAdvancedOptionsContainer');

        this.changeDigits = function () {
            var maxValue = this.generateMaxNumber(this.numDigits.value);
            var minValue = this.generateMinNumber(this.numDigits.value);
            for (var i = 0; i < this.numericRangeTextInputs.length; i++) {
                var originalValue = this.numericRangeTextInputs[i].value;
                this.numericRangeTextInputs[i].value = maxValue;
                if (this.numericRangeTextInputs[i].hasClass('rangeMin')) {
                    if (originalValue < 0) {
                        this.numericRangeTextInputs[i].value *= (-1);
                    }
                    else {
                        this.numericRangeTextInputs[i].value = minValue;
                    }
                }
            }

            return this.numDigits.value;
        };

        this.generateMaxNumber = function (numDigits) {
            var result = 1;
            for (var i = 0; i < numDigits; i++) {
                result *= 10;
            }

            return result - 1;
        };

        this.generateMinNumber = function (numDigits) {
            var result = 1;
            for (var i = 1; i < numDigits; i++) {
                result *= 10;
            }

            return result;
        };

        this.changeSign = function (name, checked) {
            var maxValue = this.generateMaxNumber(this.numDigits.value);
            var minValue = this.generateMinNumber(this.numDigits.value);

            for (var i = 0; i < this.numericRangeTextInputs.length; i++) {
                if (this.numericRangeTextInputs[i].hasClass(name + 'Min')) {
                    if (checked) {
                        this.numericRangeTextInputs[i].value = maxValue * (-1);
                    }
                    else {
                        this.numericRangeTextInputs[i].value = minValue;
                    }
                }
                else if (this.numericRangeTextInputs[i].hasClass(name + 'Max')) {
                    this.numericRangeTextInputs[i].value = maxValue;
                }
            }
        };

        this.showAdvancedOptions = function () {
            this.simpleOptionsContainer.setStyle('display', 'none');
            this.advancedOptionsContainer.setStyle('display', 'block');
        };

        this.showSimpleOptions = function () {
            this.simpleOptionsContainer.setStyle('display', 'block');
            this.advancedOptionsContainer.setStyle('display', 'none');
        };
    }

    jQuery('.digits').on('change', function () {
        var numDigits = digitsSelection.changeDigits();
        regrouping.hideIrrelevantColumns(numDigits);
        buttonActivation.activateOnlyCreateButton();
    });

    jQuery('.orientation').on('change', function () {
        buttonActivation.toggleButtons();
    });

    jQuery('.units').on('change', function () {
        buttonActivation.toggleButtons();
    });

    jQuery('.strokeWidth').on('change', function () {
        buttonActivation.toggleButtons();
    });

    jQuery('.linesPerInch').on('change', function () {
        buttonActivation.toggleButtons();
    });

    jQuery('.lines').on('change', function () {
      buttonActivation.toggleButtons();
    });

    $$('.negativeRange').addEvent('change', function () {
        digitsSelection.changeSign(this.name, this.checked);
        buttonActivation.activateOnlyCreateButton();
    });

    $$('.numericRange').addEvents({
        keyup: function () {
            this.value = removeNonNumericCharacters(this.value);
            buttonActivation.activateOnlyCreateButton();
        },
        input: function () {
            buttonActivation.toggleButtons();
        }
    });

    jQuery('.size').on('change', function () {
        buttonActivation.toggleButtons();
    });
    jQuery('.difficultyLevel').on('change', function () {
        buttonActivation.toggleButtons();
    });

    function Regrouping() {
        this.regroupingTypes = [1, 10, 100];
        this.simpleOptionsContainer = worksheetContainer.getElement('.regroupingSimpleOptionsContainer');
        this.advancedOptionsContainer = worksheetContainer.getElement('.regroupingAdvancedOptionsContainer');
        this.regroupingTypesColumns = worksheetContainer.getElements('.regroupingTypesColumn');
        this.regroupingTypesTitles = worksheetContainer.getElements('.regroupingTypesTitle');

        this.showAdvancedOptions = function () {
            this.simpleOptionsContainer.setStyle('display', 'none');
            this.advancedOptionsContainer.setStyle('display', 'block');
        };

        this.showSimpleOptions = function () {
            this.simpleOptionsContainer.setStyle('display', 'block');
            this.advancedOptionsContainer.setStyle('display', 'none');
        };

        this.toggleColumnsValues = function (value) {
            for (var i = 0; i < this.regroupingTypes.length; i++) {
                if (this.regroupingTypesColumns[i].options) {
                    for (var j = 0; j < this.regroupingTypesColumns[i].options.length; j++) {
                        if (this.regroupingTypesColumns[i].options[j].get('value') == value) {
                            this.regroupingTypesColumns[i].options[j].set('selected', 'selected');
                        }
                    }
                }
            }
        };

        this.hideIrrelevantColumns = function (numDigits) {
            this.regroupingTypesColumns.setStyle('display', 'inline-block');
            this.regroupingTypesTitles.setStyle('display', 'inline-block');
            for (var i = 0,size=this.regroupingTypes.length; i <size; i++) {
                if ( i <= size-numDigits-1) {
                    if (this.regroupingTypesColumns[i]) {
                        this.regroupingTypesColumns[i].setStyle('display', 'none');
                    }
                    if (this.regroupingTypesTitles[i]) {
                        this.regroupingTypesTitles[i].setStyle('display', 'none');
                    }
                }
            }
        }
    }

    $$('.regroupingTypes').addEvent('change', function () {
        buttonActivation.activateOnlyCreateButton();
    });

    jQuery('.letterCase').on('change', function () {
      buttonActivation.toggleButtons();
    });

    jQuery('.numberOfProblems').on('change', function () {
      buttonActivation.toggleButtons();
    });

    $$('.digitsAdvancedOptions').addEvent('click', function () {
        digitsSelection.showAdvancedOptions();
    });

    $$('.digitsSimpleOptions').addEvent('click', function () {
        digitsSelection.showSimpleOptions();
    });

    $$('.regroupingAdvancedOptions').addEvent('click', function () {
        regrouping.showAdvancedOptions();
    });

    $$('.regroupingSimpleOptions').addEvent('click', function () {
        regrouping.showSimpleOptions();
    });

    $$('.regrouping').addEvent('change', function () {
       regrouping.toggleColumnsValues(this.get('value'));
    });

    function RestrictedFirstOperand() {
        this.container = worksheetContainer.getElement('.restrictedFirstOperandValue');
        this.disabledInputs = worksheetContainer.getElements('.restrictedFirstOperandValue');
        this.sectionStatus = new SectionStatus(this.container, this.disabledInputs);

        this.activate = function () {
            this.sectionStatus.activate();
        };

        this.deactivate = function () {
            this.sectionStatus.deactivate();
        };
    }

    $$('.restrictedFirstOperand').addEvent('change', function () {
        if (this.checked) {
            restrictedFirstOperand.activate();
        }
        else {
            restrictedFirstOperand.deactivate();
        }
    });

    function SectionStatus(container, disabledInputs) {
        this.container = container;
        this.disabledInputs = disabledInputs;

        this.activate = function () {
            this.setActivationMode(1, false);
        };

        this.deactivate = function () {
            this.setActivationMode(0.5, true);
        };

        this.setActivationMode = function (opacity, disabled) {
            this.container.setStyle('opacity', opacity);
            for (var i = 0; i < this.disabledInputs.length; i++) {
                this.disabledInputs[i].set('disabled', disabled);
            }
        };
    }

    function ColorPickerSelector() {
        this.gridColor = worksheetContainer.getElement('.gridColor');
        this.colorPickerContainer = worksheetContainer.getElement('#color-picker');
        this.worksheetGeneratorColorPicker;

        this.runColorPickerAndDisplayPreview = function () {
            if (this.gridColor) {
                var gridColor = this.gridColor;
                this.worksheetGeneratorColorPicker = ColorPicker(this.colorPickerContainer,
                    function (hex, hsv, rgb) {
                        gridColor.set('value', hex);
                        gridColor.fireEvent('change');
                        var colorPickerPreview = worksheetContainer.getElement('.colorPickerPreview');
                        colorPickerPreview.setStyle('background-color', hex);
                    }
                );
                this.worksheetGeneratorColorPicker.setHex(gridColor.value);
            }
        };

        this.toggleColorPickerDisplay = function () {
            var colorPickerDisplayStatus = this.colorPickerContainer.getStyle('display');
            if (colorPickerDisplayStatus == 'none') {
                this.colorPickerContainer.setStyle('display', 'inline-block');
            }
            else {
                this.colorPickerContainer.setStyle('display', 'none');
            }
        };
    }

    colorPickerSelector.runColorPickerAndDisplayPreview();

    $$('.colorPickerPreview').addEvent('click', function () {
        colorPickerSelector.toggleColorPickerDisplay();
    });

    $$('.gridColor').addEvent('change', function () {
        buttonActivation.toggleButtons();
    });

    jQuery("#modal-help-popup").modal({
        trigger: jQuery("[data-modal = 'modal-help-btn']")
    });
});
